import { getLanguage } from 'app/locale/utils';

export const getTimeZoneName = (timeZone: string) =>
  Intl.DateTimeFormat(getLanguage(), {
    timeZoneName: 'short',
    timeZone,
  })
    .formatToParts()
    .find((i) => i.type === 'timeZoneName')?.value;
